<app-base-template (modal)="openModal(content)" (tabledata)="getTableData()" [displayData]="displayData"
  [nextOffset]="nextOffset" [previousOffset]="previousOffset" (offset)="getData($event)"
  (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage" [dataLoaded]="dataLoaded">
</app-base-template>

<ng-template #content let-c="close" let-d="dismiss">

  <div class="modal-header modalTitle">
    <div class="modal-title">Add Master</div>

  </div>
  <div class="modal-body">
    <div class="loader" [hidden]="dataLoaded"><img class="loading-gif" src="../../../assets/img/loader.gif"></div>
    <div class="none" [hidden]="isError" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>

    <div class="form-group">
      <mat-radio-group aria-label="Select an option" [(ngModel)]="selectedTypeValue" (change)="onChnageSenderType()">
        <mat-radio-button class="emailticketradiobtn" *ngFor="let senderType of senderTypeObj" [value]="senderType.id">
          {{senderType.type_text}}&nbsp;&nbsp; </mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketSelected">
        <option *ngFor="let ticket of tickets" [value]="ticket.id">{{ticket.name}}</option>
      </select>
    </div>

    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" placeholder="Enter Login ID OR Name"
        [(ngModel)]="EndUserSelectedValue" matInput [formControl]="searchUser" [matAutocomplete]="auto">
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="getUserDetails()">
        <mat-option *ngIf="isLoading" class="is-loading">
          <mat-spinner diameter="50"></mat-spinner>
        </mat-option>
        <ng-container *ngIf="!isLoading">
          <mat-option *ngFor="let user of EndUsers" [value]="user.login_name">
            {{ user.name }} - {{user.login_name}}
          </mat-option>
        </ng-container>
      </mat-autocomplete>
    </div>
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" placeholder="User Name" readonly [(ngModel)]="userName">
    </div>


    <div class="form-group" *ngIf="selectedTypeValue === '1' || selectedTypeValue === 1">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="groupSelected"
        (change)="onGroupChange($event.target.selectedIndex)">
        <option *ngFor="let group of groups" [value]="group.id">{{group.name}}</option>
      </select>
    </div>

    <div class="form-group" *ngIf="selectedTypeValue === '2' || selectedTypeValue === 2">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="roleId" (change)="onroleChange()">
        <option *ngFor="let group of roles" [value]="group.id">{{group.name}}</option>
      </select>
    </div>

    <div class="form-group" *ngIf="L3Users.length > 0">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="L3UsersSelected"
        (change)="onApproverChange($event.target.selectedIndex)">
        <option *ngFor="let ticket of L3Users" [value]="ticket.id">{{ticket.name}}</option>
      </select>
    </div> 

    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="statusSelected" (change)="onStatusChange()">
        <option *ngFor="let ticket of statusSeq" [value]="ticket.id">{{ticket.name}}</option>
      </select>
    </div>

    <div class="form-group" *ngIf="newstatusSeq.length > 0">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="newstatusSelected">
        <option *ngFor="let ticket of newstatusSeq" [value]="ticket.id">{{ticket.name}}</option>
      </select>
    </div>

  </div>

  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>

<notifier-container></notifier-container>